/** @jsxImportSource jsx-dom */

import { SuccessButton } from "../../Buttons/SuccessButton";
import { PrimaryButton } from "../../Buttons/PrimaryButton";
import { translate } from "./shared";

type LocalePickerBasketWarningProps = {
  language: string;
  currentCountryName: string;
  targetCountryName: string;
  onContinue: () => void;
  onCancel: () => void;
};

export const LocalePickerBasketWarning = ({
  language,
  currentCountryName,
  targetCountryName,
  onContinue,
  onCancel,
}: LocalePickerBasketWarningProps) => (
  <section
    class="tw:px-4 tw:pb-4 tw:flex tw:flex-col tw:gap-4"
    role="alert"
    data-testid="locale-picker-basket-warning"
  >
    <h2 class="tw:m-0">
      {translate("localepicker.basketWarning.title", language)}
    </h2>
    <p class="tw:m-0">
      {translate("localepicker.basketWarning.body", language, [
        currentCountryName,
        targetCountryName,
      ])}
    </p>
    <div class="tw:flex tw:flex-col tw:sm:flex-row tw:gap-4">
      <PrimaryButton
        variant="outline"
        cssClass="tw:flex-1"
        testId="locale-picker-basket-cancel"
        onClick={onCancel}
      >
        {translate("localepicker.basketWarning.cancel", language)}
      </PrimaryButton>
      <SuccessButton
        cssClass="tw:flex-1"
        testId="locale-picker-basket-continue"
        onClick={onContinue}
      >
        {translate(
          "localepicker.basketWarning.continue",
          language,
          targetCountryName
        )}
      </SuccessButton>
    </div>
  </section>
);
